import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Loader2, X } from "lucide-react";
import { api } from "@/lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("polling");

  useEffect(() => {
    if (!sessionId) {
      setState("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch {
        setState("error");
        return;
      }
      attempts += 1;
      if (attempts < 15) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <main data-testid="payment-success-page" className="flex min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-lg border border-white/10 bg-card p-12 text-center">
        {state === "polling" && (
          <>
            <Loader2 size={40} className="mx-auto animate-spin text-primary" />
            <h1 className="mt-6 font-anton text-3xl text-white">CONFIRMING PAYMENT</h1>
            <p className="mt-3 font-mono text-xs tracking-[0.2em] text-white/50">HOLD TIGHT...</p>
          </>
        )}
        {state === "paid" && (
          <>
            <span className="mx-auto flex h-16 w-16 items-center justify-center bg-primary text-black">
              <Check size={30} />
            </span>
            <h1 data-testid="payment-confirmed-title" className="mt-6 font-anton text-4xl text-white">
              IT'S <span className="text-primary">OFFICIAL</span>
            </h1>
            <p className="mt-3 text-white/60">
              Payment confirmed. Welcome to the Smoke — check your email for the receipt.
            </p>
          </>
        )}
        {(state === "error" || state === "timeout") && (
          <>
            <h1 data-testid="payment-pending-title" className="font-anton text-3xl text-white">STILL PROCESSING</h1>
            <p className="mt-3 text-white/60">
              Your payment is being finalized. If you were charged, it will confirm shortly.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="payment-home-button"
          className="mt-10 inline-block bg-primary px-8 py-4 font-mono text-sm font-bold tracking-[0.2em] text-black transition-transform duration-300 hover:-translate-y-1 hover:shadow-[6px_6px_0px_#fff]"
        >
          BACK TO THE SITE
        </Link>
      </div>
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-lg border border-white/10 bg-card p-12 text-center">
        <span className="mx-auto flex h-16 w-16 items-center justify-center border border-white/25 text-white/70">
          <X size={30} />
        </span>
        <h1 data-testid="payment-cancelled-title" className="mt-6 font-anton text-4xl text-white">CHECKOUT CANCELLED</h1>
        <p className="mt-3 text-white/60">No charge was made. The smoke will be here when you're ready.</p>
        <Link
          to="/merch"
          data-testid="payment-back-to-shop-button"
          className="mt-10 inline-block border border-white/30 px-8 py-4 font-mono text-sm font-bold tracking-[0.2em] text-white transition-colors duration-300 hover:border-primary hover:text-primary"
        >
          BACK TO THE SHOP
        </Link>
      </div>
    </main>
  );
}
